var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"novice-module"},[_c('div',{staticClass:"k-novice",style:(_vm.aStyle)},[_c('div',{staticClass:"receive-btn",class:{
        gray: _vm.btnStatus().style.gray,
        center: this.draw.btnLeft == -1
      },style:(_vm.btnStyle),on:{"click":_vm.startTurns}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }